import React from 'react';
import { supabase } from '../supabaseClient';
import './Auth.css';

const UserProfile = ({ user, onLogout }) => {
  const handleLogout = async () => {
    await supabase.auth.signOut();
    onLogout();
  };

  return (
    <div className="user-profile-inline">
      <div className="user-avatar">
        {(user.user_metadata?.full_name || user.email || 'U')[0].toUpperCase()}
      </div>
      <div className="user-info">
        <div className="user-name">{user.user_metadata?.full_name || user.email?.split('@')[0]}</div>
      </div>
      <button onClick={handleLogout} className="user-logout-btn">
        Logout
      </button>
    </div>
  );
};

export default UserProfile;
